import { createAction } from 'redux-actions';

import fetch from 'features/common/fetch';
import { sortContacts } from 'features/views/contacts/actions';

import * as types from './actionTypes';

export const setCampaignDetail = createAction(types.SET_CAMPAIGN_DETAIL, (campaignDetail) => ({ campaignDetail }));
export const setSort = createAction(types.SET_SORT, (sort) => ({ sort }));
export const resetCampaignDetail = createAction(types.RESET);

export const fetchCampaignDetail = (id) => (dispatch) => {
	dispatch(
		fetch.actions.get(fetch.constants.urls.campaignDetail, {
			replaceParams: { id },
			onSuccess: [
				(response) => () => {
					const campaign = response.body;
					dispatch(setCampaignDetail(campaign));
				},
			],
		}),
	);
};

export const sortRecords = (view, sort) => (dispatch) => {
	dispatch(setSort(sort));
	dispatch(sortContacts(view)(sort));
};
